import { Component, type ReactNode } from 'react';

/** A 3D failure must never take the page down: show the fallback (the v2 photo) instead. */
export class AvatarBoundary extends Component<
  { fallback: ReactNode; children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidCatch(error: unknown) {
    console.warn('Elena 3D je pala, prikazujem fotografiju', error);
  }

  override render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
